import { globalState } from './state';
const rootReducer = (state = globalState, action) => {
    switch (action.type) {
        case 'SET_LOGIN':
            return {
                ...state,
                isLogin: true
            }
        case 'SET_LOGOUT':
            return {
                ...state,
                isLogin: false
            }
        case 'ADD_PROFILE':
            return {
                ...state,
                dataProfile: action.payload
            }
        case 'ADD_SIDEBAR':
            return {
                ...state,
                sidebar: action.payload
            }
        default:
            return state
    }
}


export {
    rootReducer
}